export const getFullName = (profile: { firstName: string; lastName: string }) =>
  [profile?.firstName, profile?.lastName].filter(Boolean).join(' ');
